// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__mgIBp","desabilitar":"OptionSelect_desabilitar__L5v-X","focado":"OptionSelect_focado__q0BdB","novo":"OptionSelect_novo__1cKFL"};